import toast from 'react-hot-toast';

export interface ApiError {
  success: false;
  error: {
    message: string;
    details?: any[];
    code?: string;
  };
}

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: {
    message: string;
    details?: any[];
    code?: string;
  };
}

export class ErrorHandler {
  static handleApiError(error: any, context: string = 'Operation'): void {
    console.error(`${context} Error:`, error);

    let errorMessage = 'An unexpected error occurred';

    // Handle different error formats
    if (error?.response?.data) {
      const apiError = error.response.data as ApiError;
      errorMessage = apiError.error?.message || 'Server error occurred';
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    // Show error toast
    toast.error(errorMessage, {
      duration: 5000,
      position: 'top-right',
      style: {
        background: '#ef4444',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
      },
    });
  }

  static handleApiSuccess(message: string = 'Operation completed successfully'): void {
    toast.success(message, {
      duration: 3000,
      position: 'top-right',
      style: {
        background: '#10b981',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
      },
    });
  }

  static handleValidationError(errors: any[], context: string = 'Validation'): void {
    const errorMessages = errors.map(error => error.message).join(', ');
    const message = `${context} failed: ${errorMessages}`;
    
    toast.error(message, {
      duration: 5000,
      position: 'top-right',
      style: {
        background: '#f59e0b',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
      },
    });
  }

  static handleNetworkError(): void {
    toast.error('Network error. Please check your connection and try again.', {
      duration: 5000,
      position: 'top-right',
      style: {
        background: '#ef4444',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
      },
    });
  }

  static handleAuthError(): void {
    toast.error('Authentication failed. Please log in again.', {
      duration: 5000,
      position: 'top-right',
      style: {
        background: '#ef4444',
        color: '#fff',
        borderRadius: '8px',
        fontSize: '14px',
      },
    });
  }
}

export default ErrorHandler; 